var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-pagination", {
    staticClass: "sedap-table-pagination",
    attrs: {
      layout: "prev, pager, next",
      total: _vm.pagination.totalElements,
      "page-size": _vm.pagination.pageSize,
      "page-count": _vm.pagination.totalPages,
      "hide-on-single-page": ""
    },
    on: {
      "current-change": function($event) {
        return _vm.$emit("pageChange", $event)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bc6c157a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc6c157a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Tables/Pagination/Pagination.vue
// module id = null
// module chunks = 